<template>
    <base-modal
        :reference="'reset_buses_modal'"
        :title="'Resetear la composición de todos los buses'"
        :acceptAction="acceptAction"
        :cancelActionText="'Cancelar'"
        :size="'lg'"
    >
        <template v-slot:body v-if="show">
            
            <div class="text-left px-5">
                ¿Está seguro que quiere resetear la composición de <strong>todos los buses</strong> de la
                organización que está editando? Se reseteará
                la composición de <strong>todos los buses de excursión y de recogida</strong>. 

                <p class="mt-4">Datos de la organización por la que se ejecutará la acción:</p>

                <ul class="mt-4 ml-3">
                    <li class="my-2">Zona: {{currentSuprazone.name}}</li>
                    <li class="my-2">Grupo: {{currentGroup.name}}</li>
                    <li class="my-2">Día: {{filterDate}}</li>
                </ul>
            </div>
            
        </template>
    </base-modal>
</template>

<script>
/* eslint-disable */

import BaseModal from './../Excursions/Booking/Modal/BaseModal';
import { mapGetters } from 'vuex';


export default {
    components: {
        BaseModal,
    },
    props: {
        
    },
    data: () => {
        return {
            show: false
        }
    },
    async mounted() {
        this.$root.$on('bv::modal::show', async (bvEvent, modalId) => {
            if ( modalId === 'reset_buses_modal') {
                this.show = true

            }
        })
    },
    methods: {
        async acceptAction() {
            // perform operation to reset buses
            await this.$store.dispatch("bookingsBus/resetAllBuses")

            this.$notify({
                group: "foo",
                title: "Reseteado de buses",
                text: "Se han reseteado todas la asignaciones de los buses solicitados",
                type: "success",
            });

            this.$bvModal.hide('reset_buses_modal');
            // if ( this.activeTab != 'Excursions') {
            //     this.$router.push("/app/excursiones/excursiones")
            // }
            
            // await this.$store.dispatch("layout/setActiveTabAndOption", {tab: 'Excursions', option: 'Activity'})
            
            
            
        }
    },
    computed: {
        ...mapGetters(['filterDate', 'currentSuprazone', 'currentGroup', 'activeOption', 'activeTab'])
    }
}
</script>

<style scoped>
p {
    margin-bottom: 1px;
}
</style>